import DataTable from "./DataTable";
import TableToolbar from "./TableToolbar";
import useTableFilters from "../../hooks/useTableFilters";

export default function FilteredDataTable({
  data,
  columns,
  config,
  initialFilters,
  pageSize = 10,
  emptyMessage = "No records match your filters.",
  onRowClick,
  compact = false,
  toolbarClassName = "",
  tableClassName = "",
  maxVisibleColumns,
}) {
  const filterState = useTableFilters(data, config, initialFilters);
  const {
    filtered,
    filters,
    setFilter,
    resetFilters,
    removeFilter,
    activeCount,
    activeChips,
    metrics,
    drawerOpen,
    setDrawerOpen,
    fieldOptions,
  } = filterState;

  return (
    <div className={tableClassName}>
      <TableToolbar
        config={config}
        filters={filters}
        setFilter={setFilter}
        resetFilters={resetFilters}
        removeFilter={removeFilter}
        activeCount={activeCount}
        activeChips={activeChips}
        metrics={metrics}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        fieldOptions={fieldOptions}
        totalCount={data.length}
        filteredCount={filtered.length}
        className={`mb-4 ${toolbarClassName}`}
      />
      <DataTable
        columns={columns}
        data={filtered}
        pageSize={pageSize}
        emptyMessage={emptyMessage}
        onRowClick={onRowClick}
        compact={compact}
        maxVisibleColumns={maxVisibleColumns}
      />
    </div>
  );
}

export { useTableFilters };
